import type { FloorContentDM, FloorDM } from '@Model/FloorModels';
import type { TransientClass } from '@Utils/useClassStore';
import { ObservableProp } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { action } from 'mobx';

import { FloorGateway } from '~gateways/floor';
import container from '~ioc/ioc';

@injectable()
export class FloorStore implements TransientClass {
  @inject(FloorGateway) private _floorGateway?: FloorGateway;

  isFetching = new ObservableProp(false);
  data?: FloorDM;
  content = new ObservableProp<FloorContentDM | undefined>(undefined);
  fetchError = new ObservableProp<string | undefined>(undefined);

  init = (data: FloorDM) => {
    this.data = data;
  };

  @action fetch = async () => {
    if (!this._floorGateway) {
      throw new Error(
        'FloorStore was not initialized with a gateway while attempted to fetch data.'
      );
    }

    this.isFetching.set(true);
    try {
      this.fetchError.set(undefined);
      const result = await this._floorGateway.getFloor(this.data?.id);
      this.content.set(result);
    } catch (error) {
      this.fetchError.set((error as Error).message);
    } finally {
      this.isFetching.set(false);
    }
  };

  destroy = () => {
    /* do nothing */
  };
}

container.bind(FloorStore).toSelf().inTransientScope();

export const getFloorStore = (data: FloorDM) => {
  const store = container.get(FloorStore);
  store.init(data);

  return store;
};
